var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("tree-wiki"),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "top", appear: "" } },
        [
          _vm.isWikiAdmin
            ? _c(
                "q-page-sticky",
                { attrs: { position: "top-right", offset: [8, 8] } },
                [
                  _c("q-btn", {
                    attrs: { round: "", color: "secondary", icon: "add" },
                    on: { click: _vm.doArticleAdd }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2b7328ed", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b7328ed","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/wiki-list.vue
// module id = null
// module chunks = 